<section *ngIf="!errormessage">
    <mat-card appearance="outlined" style="width: 1376px;">
        <div style="border-color: black;">
            <h3 style="font-weight: 500;">Assessment Details</h3>
            <table>                
                <tr>                                                               
                    <td>
                        <label style="padding-right: 10px;font-weight: bold;">Date Raised</label>
                        <mat-form-field appearance="outline">
                            <mat-label>Choose a date</mat-label>
                            <input matInput #dateraised="ngModel" [matDatepicker]="myDatepicker" id="DateRaised" [(ngModel)]="objAssclass.DateRaised" name="DateRaised" required>
                            <mat-datepicker-toggle [for]="myDatepicker" matSuffix></mat-datepicker-toggle>
                            <mat-datepicker #myDatepicker></mat-datepicker>
                            <mat-error *ngIf="dateraised.hasError('required')">This field is required</mat-error>  
                        </mat-form-field>
                    </td> 

                    <td>
                        <label style="margin-left: 65px;padding-right: 10px;font-weight: bold;">Client</label>
                        <mat-form-field appearance="outline">
                            <mat-label>Select</mat-label>
                            <mat-select id="ClientName" #client="ngModel" [(ngModel)]="objAssclass.ClientName" name="ClientName" required >
                                <mat-option  *ngFor="let lang of DDdataEVClient" value="{{lang.Client}}">  
                                {{lang.Client}}</mat-option>                
                            </mat-select>                            
                            <mat-error *ngIf="client.hasError('required')">This field is required</mat-error>           
                        </mat-form-field> 
                    </td>   
                                    
                    <td>
                        <label style="margin-left: 65px;padding-right: 10px;font-weight: bold;">Contract</label>
                        <mat-form-field appearance="outline">
                            <mat-label>Select</mat-label>
                            <mat-select id="ContractNumber" #ContractNumber="ngModel" [(ngModel)]="objAssclass.ContractNumber" name="ContractNumber" required >
                                <mat-option  *ngFor="let lang of DDdataEVContrNum" value="{{lang.ContractNumber}}">  
                                {{lang.ContractNumber}}</mat-option>                
                            </mat-select>                            
                            <mat-error *ngIf="ContractNumber.hasError('required')">This field is required</mat-error>           
                        </mat-form-field> 
                    </td>

                    <td>
                        <label style="margin-left: 62px;padding-right: 10px;font-weight: bold;">Contract Name</label>
                        <mat-form-field appearance="outline">
                            <mat-label>Select</mat-label>
                            <mat-select id="ContractName" #contractname="ngModel" [(ngModel)]="objAssclass.ContractName" name="ContractName" required >
                                <mat-option *ngFor="let lang of DDdataEVContrName" value="{{lang.ContractName}}">  
                                {{lang.ContractName}}</mat-option>                
                            </mat-select>  
                            <mat-error *ngIf="contractname.hasError('required')">This field is required</mat-error>              
                        </mat-form-field> 
                    </td>
                </tr>
            </table>
            <table>
                <tr>
                    <td>
                        <label style="padding-right: 10px;font-weight: bold;">Title</label>                   
                        <mat-form-field appearance="outline" style="width: 1300px;">
                            <mat-label>Input</mat-label>
                            <input matInput #title="ngModel" style="width: 750px;" id="iTitleAssess" [(ngModel)]="objAssclass.AssessmentName" name="TitleAssess" required>
                            <mat-error *ngIf="title.hasError('required')">This field is required</mat-error> 
                        </mat-form-field>
                    </td>
                </tr>
            </table>
            <table>
                <tr>
                    <td>
                        <form [formGroup]="productForm" >      
                            <table  formArrayName="quantities">
                              <tr>
                                <label style="font-weight: bold;">Question</label>     
                              </tr>
                              <tr *ngFor="let quantity of quantities().controls; let i=index" [formGroupName]="i">
                                <td style="display: none">
                                    <mat-form-field appearance="outline" style="width: 1335px;">                                                                           
                                      <textarea matInput rows="3" class="form-control" formControlName="QuestionID"></textarea>
                                  </mat-form-field>
                                </td>
                                <td>
                                    <mat-form-field appearance="outline" style="width: 1335px;">
                                      <mat-label>Textarea</mat-label>                                      
                                      <textarea matInput rows="3" class="form-control" formControlName="Question"></textarea>
                                  </mat-form-field>
                                </td>         
                                <td>                                    
                                    <img src="assets/Minus Sign.svg" style="width:20px" id="AssessMinusbutton{{i}}" *ngIf="i > 0" (click)="removeQuantity(i)"/>
                                </td>
                              </tr>
                              <tr>                                
                                <img src="assets/Plus Sign.svg" style="width:20px" id="Assessplusbutton" (click)="addQuantity()"/>
                            </tr>
                            </table>                             
                          </form>
                    </td>
                </tr>
            </table>
            <div align="center">               
                <button (click)="onSubmit()" class="buttonnewvul">Save</button>                        
                <button (click)="onCancel()" class="buttonnewvul" style="margin-left: 10px;">Cancel</button>  
                <a  *ngFor="let lang of EmailData" href="mailto:{{lang.AddressTo}}?cc={{lang.AddressCC}}&subject={{lang.EmailSubject}}" style="text-decoration: none !important;line-height: 12px;margin-top: 0px;" class="btn buttonnewvul" >Publish</a>                                                 
            </div>
        </div>
    </mat-card>
</section>
